import React from "react";
import { Modal } from "../";

const PaymentsHowItWorksModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Online Payments - How it works"
      maxWidth="max-w-2xl"
    >
      <div className="space-y-4">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-500/10">
              <svg
                className="h-5 w-5 text-blue-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>
          <div className="flex-1">
            <h3 className="mb-2 text-lg font-medium text-white">
              Connect Stripe to enable online payments
            </h3>
            <p className="leading-relaxed text-gray-300">
              Press connect with stripe to start the configuration with your
              stripe account. Follow the steps and fill all the information
              required. Once completed, you will be ready to receive card
              payments
            </p>
            <p className="mt-3 leading-relaxed text-gray-300">
              <span className="font-medium text-white">Note:</span> If the
              configuration is not completed or any information is missing, the
              dashboard will show you the required actions. Please follow the
              instructions that appears in the required steps section and press
              the Fix in stripe button to make the required changes. Once
              completed, it can take some minutes for the dashboard to update
              the status. You can use the refresh button to update it
            </p>
          </div>
        </div>

        <div className="flex justify-end space-x-3 pt-4">
          <button
            type="button"
            aria-label="Close how it works modal"
            onClick={onClose}
            className="rounded-md border border-gray-700 bg-gray-800 px-4 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none"
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentsHowItWorksModal;
